export default __webpack_public_path__ + "static/media/waiting_3.2fa2e472.png";